import React from 'react';
import { ContactsForm } from './Form';

export default function ContactsEdit(props) {
    return <ContactsForm {...props} />;
}
